import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { LuRefreshCw } from "react-icons/lu";
import CaptchaCanvas from '../../../components/CaptchaCanvas.js';
import { sanitizeUsername, usernameRules, onlyDigits } from "../utils/registerUtils.js";

// Checklist validasi Username
const ChecklistValidasiUsername = ({ username }) => {
    const rules = usernameRules(username);

    return (
        <ul className="list-unstyled mt-2 mb-1">
            <li className={rules.minLength ? "text-success" : "text-danger"}>
                {rules.minLength ? "✔" : "✖"} Minimal 5 karakter
            </li>
            <li className={rules.startWithLetterOrDigit ? "text-success" : "text-danger"}>
                {rules.startWithLetterOrDigit ? "✔" : "✖"} Diawali huruf atau angka
            </li>
            <li className={rules.validChars ? "text-success" : "text-danger"}>
                {rules.validChars ? "✔" : "✖"} Hanya huruf kecil, angka, underscore (_) atau titik (.)
            </li>
            <li className={rules.noSpace ? "text-success" : "text-danger"}>
                {rules.noSpace ? "✔" : "✖"} Tanpa spasi
            </li>
        </ul>
    );
};

const UserForm = ({
    user, setUser,
    trade, tradeFound,
    files, setFiles,
    namaUPT,
    captcha,
    setTextCaptcha,
    services, setServices,
    onClickUPT,
    refreshCaptcha,
}) => {
    const disabled = tradeFound;

    const handleUsernameChange = (e) => {
        const clean = sanitizeUsername(e.target.value);
        setUser({ ...user, USERNAME: clean });
    };

    return (
        <>
            {/* Nama Pengguna */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Nama Pengguna*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        required
                        placeholder="Nama Pengguna (Sesuai Nama KTP)"
                        value={user.NAMA || ""}
                        disabled={disabled}
                        onChange={(e) => setUser({ ...user, NAMA: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Jabatan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Jabatan*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Jabatan"
                        value={user.JABATAN || ""}
                        disabled={disabled}
                        onChange={(e) => setUser({ ...user, JABATAN: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* No Identitas */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0">
                    No. Identitas KTP/KITAS*
                </Form.Label>
                <Col sm="9">
                    <Row className="mb-2">
                        <Col sm="3">
                            <select
                                className="form-select shadow-none"
                                value={user.JNS_ID}
                                onChange={(e) => setUser({ ...user, JNS_ID: e.target.value })}
                            >
                                <option value="">Pilih Identitas</option>
                                <option value="1">KTP</option>
                                <option value="2">SIM</option>
                                <option value="3">Kartu Keluarga</option>
                            </select>
                        </Col>
                        <Col sm="9">
                            <Form.Control
                                type="text"
                                inputMode="numeric"
                                pattern="\d{10,16}"
                                maxLength="16"
                                placeholder="Nomor Identitas"
                                value={user.NO_ID || ""}
                                disabled={disabled}
                                onChange={(e) => setUser({ ...user, NO_ID: onlyDigits(e.target.value) })}
                                title="Nomor identitas harus berupa angka (10-16 digit)"
                                required
                            />
                        </Col>
                    </Row>
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        onChange={(e) => setFiles((f) => ({ ...f, ktp: e.target.files[0] }))}
                    />
                </Col>
            </Form.Group>

            {/* Alamat Rumah */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Alamat Rumah
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Jalan / No / Rt / Rw
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="3"
                        placeholder="Alamat Rumah"
                        value={user.ALAMAT || ""}
                        disabled={disabled}
                        onChange={(e) => setUser({ ...user, ALAMAT: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Email Pengguna */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Pos Elektronik / Email*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="email"
                        placeholder="Email Pengguna"
                        value={user.EMAIL || ""}
                        disabled={disabled}
                        onChange={(e) => setUser({ ...user, EMAIL: e.target.value.trim() })}
                        pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                        title="Masukkan format email yang valid, contoh: nama@domain.com"
                        required
                    />
                </Col>
            </Form.Group>

            {/* Nomor Handphone */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Nomor Handphone*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Nomor Handphone"
                        value={user.TELEPON || ""}
                        disabled={disabled}
                        onChange={(e) => setUser({ ...user, TELEPON: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* UPT */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Unit Pelaksana Teknis
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    UPT*
                </Form.Label>
                <Col sm="9">
                    <Row>
                        <Col sm="11">
                            <Form.Control type="text" placeholder="UPT" value={namaUPT} disabled />
                        </Col>
                        <Col sm="1" className="align-self-center">
                            <Button size="sm" variant="primary" onClick={onClickUPT}>
                                <FaSearch />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Form.Group>

            {/* Username */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Data User Login
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    User Name*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="User Name (huruf kecil, tanpa spasi)"
                        value={tradeFound ? "" : (user.USERNAME || "")}
                        disabled={disabled}
                        onChange={handleUsernameChange}
                        pattern="^[a-z0-9][a-z0-9_.]{4,}$"
                        minLength={5}
                        title="Minimal 5 karakter, diawali huruf atau angka, hanya huruf kecil/angka/underscore/titik"
                        required
                    />
                    {!disabled && <ChecklistValidasiUsername username={user.USERNAME} />}
                </Col>
            </Form.Group>

            {/* Captcha */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Security Code*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Security Code"
                        onChange={(e) => setTextCaptcha(e.target.value)}
                        required
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5" />
                <Col sm="2" className="d-flex align-items-center gap-2">
                    <Button size="sm" variant="primary" onClick={refreshCaptcha}>
                        <LuRefreshCw />
                    </Button>
                    <CaptchaCanvas text={captcha} />
                </Col>
            </Form.Group>

            {/* Jenis Layanan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Jenis Layanan*
                </Form.Label>
                <Col sm="9">
                    <Row>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                id="checkSMKHP"
                                label="Sertifikasi SMKHP"
                                checked={services.first}
                                onChange={() => setServices((s) => ({ ...s, first: !s.first }))}
                            />
                        </Col>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                id="checkPBUMKU"
                                label="PBUMKU"
                                checked={services.second}
                                onChange={() => setServices((s) => ({ ...s, second: !s.second }))}
                            />
                        </Col>
                    </Row>
                </Col>
            </Form.Group>
        </>
    );
};

export default UserForm;